var spectacularwidget = function(me) {
	me.innerHTML = 'this is so spectacular!';
};

window.spectacularwidget = spectacularwidget;
